import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15225 17655"
    {...props}
  >
    <path
      d="M15225 11973c0 544-131 1133-402 1765-266 632-687 1253-1264 1861-573 612-1308 1105-2199 1487-895 378-1936 569-3125 569-899 0-1718-84-2458-255-735-171-1407-437-2008-799-600-358-1157-835-1662-1424-449-536-835-1133-1153-1797s-557-1376-716-2127C79 10497 0 9698 0 8851c0-1372 199-2604 600-3690 398-1089 974-2020 1718-2791 748-771 1619-1360 2620-1766C5940 203 7010 0 8143 0c1384 0 2613 274 3694 827 1078 549 1905 1233 2481 2044 573 811 863 1575 863 2298 0 398-143 744-421 1050-279 302-616 453-1014 453-442 0-775-107-994-314-223-210-469-572-740-1085-453-847-982-1480-1590-1901-613-417-1360-628-2255-628-1423 0-2553 541-3396 1618-843 1082-1264 2616-1264 4605 0 1328 187 2433 561 3316 369 883 898 1539 1582 1976 684 433 1483 652 2402 652 994 0 1833-246 2521-739s1205-1217 1555-2176c147-449 330-815 548-1101 215-282 565-425 1046-425 414 0 767 143 1062 433 294 286 441 644 441 1070z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
